import React, { useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
// Components
import PageFooter from "components/CBPageFooter";
import SchemaComponent from "components/CBSchema";
import SEO from "components/CBSEO";
import PageHeader from "components/CBPageHeader";
import FAQContent from "components/CBFAQ";
import SearchBarComponent from "components/CBSearchBar";
import { TwoColumnSection } from "styles/components/twoColumnSection";
import { StyledMainPageContainer } from "index.styles";
// Utils
import { faqFilterFunction } from "utils/helpers/searchBarFilters/faq.filter";
import { SearchBar } from "utils/context/searchBar.context";
import { constructSchemaData } from "utils/helpers/constructSchemaData";
import { SearchBarProvider } from "utils/context/searchBar.context";
import useDynamicPageRenderer from "utils/hooks/useDynamicPageRenderer";
import { extractFaqDataFromContent } from "utils/helpers/getFaqData";
// Data
import faqData from "./data/pageContentData/faq.data.json";
import ketamineFaqData from "./data/pageContentData/ketamineFaq.data.json";
import faqSeoData from "./data/seoData/faqSeo.data.json";
import ketamineSeoData from "./data/seoData/ketamineFaqSeo.data.json";
import faqSchemaData from "./data/schemaData/faqSchema.data.json";
import ketamineSchemaData from "./data/schemaData/ketamineFaqSchema.data.json";

const contentMap = {
  "faq": faqData,
  "ketamine-therapy": ketamineFaqData,
};

const seoMap = {
  "faq": faqSeoData,
  "ketamine-therapy": ketamineSeoData,
};

const schemaMap = {
  "faq": faqSchemaData,
  "ketamine-therapy": ketamineSchemaData,
};

const componentMap = {
  "Faq": FAQContent,
  "PageHeader": PageHeader,
  "SearchBarComponent": SearchBarComponent,
  "TwoColumnSection": TwoColumnSection,
};

const SPREAD_PROPS_COMPONENTS = ["PageHeader"];

const FaqContent = () => {
  const location = useLocation();
  const modalityType = location.pathname.split("/")[1];
  const content = contentMap[modalityType] || [];
  const seoData = seoMap[modalityType] || {};
  const schemaDataRaw = schemaMap[modalityType] || [];
  const schemaData = schemaDataRaw.url ? constructSchemaData(schemaDataRaw.url, schemaDataRaw.breadcrumbs) : [];

  const { filteredData } = useContext(SearchBar);

  const renderedComponents = useDynamicPageRenderer(content, componentMap, SPREAD_PROPS_COMPONENTS, { filteredFaqData: filteredData });

  return (
    <StyledMainPageContainer id="faq-page-container">
      <SchemaComponent schemas={schemaData} />
      <SEO title={seoData.title} description={seoData.description} canonicalUrl={seoData.canonicalUrl} />
      {renderedComponents}
      <PageFooter content="Didn't Find What You Are Looking For?" to="/contact-us" buttonText={"Contact Our Team Today!"} internalLink="true" />
    </StyledMainPageContainer>
  );
};

const Faq = () => {
  const location = useLocation();
  const modalityType = location.pathname.split("/")[1];
  const content = contentMap[modalityType] || [];

  const initialData = useMemo(() => {
    return extractFaqDataFromContent(content);
  }, [content]);

  return (
    <SearchBarProvider initialData={initialData} filterFunction={faqFilterFunction}>
      <FaqContent />
    </SearchBarProvider>
  );
};

export default Faq;
